import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import MapContainer from '../../GoogleMap'


class ItemTop extends React.Component {
    render() {
        const { position, marker, city, slug, title } = this.props;
        return(
            <>
                <MapContainer mapCenter={position} zoom={15} markers={marker} single={true}/>
                <SingleTitle>
                { city && city !== "moscow" ? 
                            <Link to={`/${city}/${slug}`}>{title}</Link> :
                            <Link to={`/${slug}`}>{title}</Link> }         
                </SingleTitle>
            </>
        )
    }
}


const SingleTitle = styled.h1`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background: rgba(0, 0, 0, 0.7);
  padding: 5px 0 10px;
  color: #fff;
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  letter-spacing: 0.5px;
  
  a {
    color: #fff;
  }
`;


export default ItemTop